var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.513,
    height: 116.078,
    viewBox: "0 0 120.513 116.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#54bbac}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    transform: "translate(-852.739 -1081.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    transform: "rotate(-115 825.834 316.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    fill: "#efefef",
    d: "M70.365 10.212c-18.588 0-31.352-9.628-40.308-9.628S2.29 5.733 2.29 46.935s25.31 47.25 35.157 47.25c46.131.002 65.836-83.973 32.918-83.973z",
    transform: "translate(-2.29 -.584)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "invest",
    transform: "translate(867 1086.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    transform: "translate(17.22 60.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    d: "M41.492 56.746C30.537 56.746 12 55.193 12 49.373S30.537 42 41.492 42s29.492 1.553 29.492 7.373-18.538 7.373-29.492 7.373z",
    className: "cls-2",
    transform: "translate(-12 -42)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    transform: "translate(1 5.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    d: "M54.81 40.288l3.79-4.873a4.411 4.411 0 0 1-2.334-1.8l-5.081 6.532q-2.238-.062-4.472-.063C24.552 40.082 1 44.733 1 53.353V62.2c0 8.62 23.552 13.271 45.712 13.271s45.712-4.65 45.712-13.271v-8.847c0-7.572-18.174-12.081-37.614-13.065zm-8.1 2.743c26.5 0 42.763 6.012 42.763 10.322S73.207 63.675 46.712 63.675 3.949 57.663 3.949 53.353s16.268-10.322 42.763-10.322zm-28.015 20.93V69.8c-2.193-.5-4.167-1.037-5.9-1.607v-5.752c1.82.56 3.8 1.069 5.9 1.52zm2.949.58c1.895.344 3.868.644 5.9.9v5.9c-2.089-.274-4.061-.587-5.9-.935zm8.847 1.249c1.933.2 3.9.372 5.9.5v5.91c-2.05-.131-4.02-.3-5.9-.5zm8.847.662c1.961.09 3.933.146 5.9.164v5.9c-2.028-.018-4-.068-5.9-.152zm8.847.162c1.966-.018 3.937-.074 5.9-.164v5.91c-1.9.084-3.871.134-5.9.152zm8.847-.323c1.994-.13 3.965-.3 5.9-.5V71.7c-1.879.2-3.849.367-5.9.5zm8.847-.846c2.03-.26 4-.562 5.9-.9v5.872c-1.837.348-3.809.661-5.9.935zm8.847-1.483c2.1-.451 4.079-.96 5.9-1.522v5.752c-1.731.572-3.706 1.112-5.9 1.607zM3.949 62.2v-3.907a23.337 23.337 0 0 0 5.9 3.131v5.666c-3.837-1.613-5.9-3.359-5.9-4.89zm79.627 4.891v-5.666a23.337 23.337 0 0 0 5.9-3.131V62.2c-.001 1.531-2.064 3.277-5.9 4.892z",
    transform: "translate(-1 8.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    d: "M32.424 29.644h2.949v-2.949a4.424 4.424 0 1 0 0-8.847h-2.949a1.475 1.475 0 1 1 0-2.949h4.424v1.475H39.8v-4.425h-4.427V9h-2.949v2.949a4.424 4.424 0 1 0 0 8.847h2.949a1.475 1.475 0 1 1 0 2.949h-4.424v-1.474H28v4.424h4.424z",
    transform: "translate(11.814 -3.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    d: "M22.424 37.441H33.07l2.312 9.25a3.362 3.362 0 0 0 6.524 0l2.312-9.249h10.646a4.429 4.429 0 0 0 4.424-4.424V9.424A4.429 4.429 0 0 0 54.864 5h-32.44A4.429 4.429 0 0 0 18 9.424v23.593a4.429 4.429 0 0 0 4.424 4.424zM20.949 9.424a1.475 1.475 0 0 1 1.475-1.475h32.44a1.475 1.475 0 0 1 1.475 1.475v23.593a1.475 1.475 0 0 1-1.475 1.475H41.918l-2.871 11.482a.431.431 0 0 1-.8 0l-2.876-11.482H22.424a1.475 1.475 0 0 1-1.475-1.475z",
    transform: "translate(7.068 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    d: "M60.705 26.325a5.85 5.85 0 0 1-2.6-1.4l-5.655 10.5a4.4 4.4 0 0 1 2.6 1.4z",
    transform: "translate(23.419 4.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    d: "M44.222 31.775c.009.112.034.218.034.332a4.395 4.395 0 0 1-.795 2.519l8.2 2.237c-.009-.112-.034-.218-.034-.332a4.395 4.395 0 0 1 .795-2.519z",
    transform: "translate(19.151 7.707)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    transform: "translate(55.559 41.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    d: "M42.424 37.847a4.424 4.424 0 1 1 4.424-4.424 4.429 4.429 0 0 1-4.424 4.424z",
    className: "cls-2",
    transform: "translate(-38 -29)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    transform: "translate(71.78 45.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    d: "M53.424 40.847a4.424 4.424 0 1 1 4.424-4.424 4.429 4.429 0 0 1-4.424 4.424z",
    className: "cls-2",
    transform: "translate(-49 -32)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    transform: "translate(80.627 25.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    d: "M60.9 29.8a5.9 5.9 0 1 1 5.9-5.9 5.9 5.9 0 0 1-5.9 5.9z",
    className: "cls-2",
    transform: "translate(-55 -18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1225",
    transform: "translate(3.949 29.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    d: "M22.169 23.949H11.847V21L3 26.9l8.847 5.9v-2.953h10.322z",
    className: "cls-2",
    transform: "translate(-3 -21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1226",
    transform: "translate(70.305 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    d: "M48 11.847h10.322V14.8l8.847-5.9L58.322 3v2.949H48z",
    className: "cls-2",
    transform: "translate(-48 -3)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfit);
export default __webpack_public_path__ + "static/media/PROFIT.81fd8e3f72429f8f1ce7300c45f93f79.svg";
export { ForwardRef as ReactComponent };